import React from 'react';
import ReportUpload from './ReportUpload';

const SentReports = () => {
  return <ReportUpload mode="sent" />;
};

export default SentReports;
